import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { stat } from "fs";
import { bgColor , borderColor } from "../styled";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
  },
};



const StatisticsBarChart = ({ barChartLabels }) => {
  const data = {
    labels: barChartLabels,
    datasets: [
      {
        label: "Last month",
        data: barChartLabels.map(() => Math.random(1, 100)),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "This month",
        data: barChartLabels.map(() => Math.random(1, 100)),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };
  return <Bar options={options} data={data} />;
};

export function bookingReportBarChart(res){
  const barChartLabels = Object.keys(res)
  let lableArr = []
  let datasets = []
  for(let item in res[barChartLabels[0]]){
    if (typeof(res[barChartLabels[0]][item])!== 'object'){
      lableArr.push(item)
    }
  }
  let count = 0
  for(let lbl of lableArr){
    let dataArr = []
    for(let state of barChartLabels){
      dataArr.push(res[state][lbl])
    }
    datasets.push({
      label : lbl,
      data : dataArr,
      backgroundColor : bgColor[count]
    })
    count++
  }
  
  const data = {
    labels: barChartLabels,
    datasets: datasets
  };
  return <Bar options={options} data={data} />;
};
export function bookingBarChart(dataset,item){
  const data = dataset[item]
  if(data && Object.keys(data).length > 0){
    return <Bar options={options} data={data} />;
  }
  
};



export function bookingBarDataMake(data){
  let lable = []
    let datasetTeachers = []
    let datasetIns = []
    let datasetmorning = []
    let datasetevening = []
    let datasetafternoon = []
    for(let state in data){
      lable.push(state)
      datasetTeachers.push(Object.keys(data[state]['teachers']).length)
      datasetIns.push(Object.keys(data[state]['institute']).length)
      datasetmorning.push(data[state].time['Morning'] || 0)
      datasetevening.push(data[state].time['Evening'] || 0)
      datasetafternoon.push(data[state].time['Afternoon'] || 0)
    }
    return {
      teachers : {
        labels: lable,
        datasets: [{
          label : 'Active Teachers',
          data : datasetTeachers,
          backgroundColor : bgColor[0]
        }]
      },
      institute : {
        labels: lable,
        datasets: [{
          label : 'Active Intitutions',
          data : datasetIns,
          backgroundColor : bgColor[1]
        }]
      },
      time : {
        labels: lable,
        datasets: [
          {
            label : 'Morning',
            data : datasetmorning,
            backgroundColor : bgColor[0]
          },{
            label : 'Afternoon',
            data : datasetafternoon,
            backgroundColor : bgColor[1]
          },{
            label : 'Evening',
            data : datasetevening,
            backgroundColor : bgColor[2]
          }
        ]
      }
    }
}

export function topTen(rawdata,state,cat){
  if(Object.keys(rawdata).length > 0){
  const data = state === 'total'
  ? rawdata[state][cat]
  : rawdata[cat][state]
  const color = cat === 'customer'
  ? bgColor[3]
  : bgColor[4]
  const lbl = cat === 'customer'
  ? 'Booking'
  : 'Classes'
  const lables = Object.keys(data)
  let dataset = Object.values(data)
  const dataSet = {
    labels: lables,
    datasets : [{
      label: lbl,
      data: dataset,
      backgroundColor: color,
    }]
  };
  return <Bar options={{
    responsive: true,
    indexAxis: 'y',
    plugins: {
      legend: {
        position: "top",
      },
    },
  }} data={dataSet} />;
}
}
export default StatisticsBarChart;
